import React, {useEffect, useState} from 'react'
import QuestionToolbar from '../../../components/screens/surveyForms/questions/QuestionToolbar'
import QuestionCanvas from '../../../components/screens/surveyForms/questions/QuestionCanvas'
import QuestionPreview from '../../../components/screens/surveyForms/questions/QuestionPreview'
import SurveySettings from './SurveySettings'
import QuestionLibrary from './QuestionLibrary'
import QuestionsList from './QuestionsList'
import AddedQuestions from './AddedQuestions'
import {useParams} from 'react-router-dom'
import surveyQuestionApi from '../../../services/api/surveys/surveyQuestionApi'
import {Backdrop, CircularProgress} from '@mui/material'
import {surveysApi} from '../../../services'
import {AUDIENCE} from '../../../utils/constants'
import Themes from './Themes'
import themesApi from '../../../services/api/themes/themeApi.js'

export default function QuestionPanel() {
  const {token} = useParams()

  const [loading, setLoading] = useState(false)
  const [loadingTheme, setLoadingTheme] = useState(false)
  const [loadingQuestions, setLoadingQuestions] = useState(false)
  const [view, setView] = useState('main')
  const [index, setIndex] = useState(null)
  const [survey, setSurvey] = useState(null)
  const [questions, setQuestions] = useState([])
  const [theme, setTheme] = useState(null)

  const handleAddNewQuestion = val => {
    setIndex(questions?.length)

    val.audiences = survey.audience
    setQuestions([
      ...questions,
      {
        ...val,
        order: questions?.length - 1,
        questionSettings: {...val.questionSettings},
        sliderResponseAttributes: {...val.sliderResponseAttributes},
        multiOptionResponseAttributes: val?.multiOptionResponseAttributes
          ? [...val.multiOptionResponseAttributes]
          : null,
        followupQuestions: val.followupQuestions
          ? [...val.followupQuestions]
          : null,
        openResponseAttributes: {...val.openResponseAttributes},
      },
    ])
  }
  useEffect(() => {
    setLoading(true)
    surveysApi
      .get(token)
      .then(res => {
        setSurvey({...res})
        setLoadingTheme(true)
        themesApi
          .getSurveyThemes(res.id, res.schoolId, res.matId)
          .then(t => {
            if (t) {
              setTheme({...t})
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => setLoadingTheme(false))
      })
      .finally(() => setLoading(false))
    setLoadingQuestions(true)
    surveyQuestionApi
      .getByToken(token)
      .then(res => {
        let qs = []
        if (res && res.length > 0) {
          qs = [
            ...res.map(q => {
              const categoryId =
                q.categoryId ?? q.categoryID ?? q.CategoryId ?? null
              const categoryName =
                q.categoryName ??
                q.categoryname ??
                q.CategoryName ??
                q.category?.name ??
                null
              return {
                ...q,
                categoryId,
                categoryName,
                questionSettings: {...q.questionSettings},
                sliderResponseAttributes: {...q.sliderResponseAttributes},
                multiOptionResponseAttributes: [
                  ...q.multiOptionResponseAttributes,
                ],
                followupQuestions: [...q.followupQuestions],
                openResponseAttributes: {...q.openResponseAttributes},
              }
            }),
          ]
        }
        setQuestions(qs)
      })
      .catch(err => console.log(err))
      .finally(() => setLoadingQuestions(false))
  }, [])

  const checkUnsavedChanges = () => {
    if (questions.filter(q => q.id === 0).length > 0) {
      return true
    }
    return false
  }

  const getAudience = audience => {
    switch (audience) {
      case AUDIENCE.STAFF + AUDIENCE.PARENT:
        return [AUDIENCE.STAFF, AUDIENCE.PARENT]
      case AUDIENCE.STAFF + AUDIENCE.STUDENT:
        return [AUDIENCE.STAFF, AUDIENCE.STUDENT]
      case AUDIENCE.PARENT + AUDIENCE.STUDENT:
        return [AUDIENCE.PARENT, AUDIENCE.STUDENT]
      case AUDIENCE.STAFF + AUDIENCE.PARENT + AUDIENCE.STUDENT:
        return [AUDIENCE.STAFF, AUDIENCE.PARENT, AUDIENCE.STUDENT]
      default:
        return [audience]
    }
  }
  return loading || loadingQuestions || loadingTheme ? (
    <Backdrop
      open={loading || loadingQuestions || loadingTheme}
      sx={theme => ({color: '#fff', zIndex: theme.zIndex.drawer + 1})}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <div className="question-panels">
      <QuestionToolbar
        view={view}
        setView={setView}
        onScreenChange={checkUnsavedChanges}
      ></QuestionToolbar>
      <QuestionCanvas>
        {view === 'library' || view === 'inventory' ? (
          <QuestionLibrary
            survey={survey}
            view={view}
            questions={questions}
            setQuestions={setQuestions}
          ></QuestionLibrary>
        ) : view === 'settings' ? (
          <SurveySettings
            survey={survey}
            setSurvey={setSurvey}
          ></SurveySettings>
        ) : view === 'themes' ? (
          <Themes
            survey={survey}
            surveyTheme={theme}
            setTheme={setTheme}
          ></Themes>
        ) : (
          <>
            <QuestionsList
              survey={survey}
              questions={questions}
              onQuestionChange={questions => setQuestions([...questions])}
              index={index}
              setIndex={setIndex}
              priorityAudience={
                survey?.audience ? getAudience(survey?.audience) : [1]
              }
            ></QuestionsList>
            <AddedQuestions onChange={handleAddNewQuestion}></AddedQuestions>
          </>
        )}
      </QuestionCanvas>
      <QuestionPreview
        tabs={survey?.audience ? getAudience(survey?.audience) : [1]}
        hasQuestion={questions?.length > 0}
        question={
          questions
            ? {
                ...questions[index],
              }
            : null
        }
        theme={theme}
      ></QuestionPreview>
    </div>
  )
}
